import httpClient from 'services/httpClient';
import { lcmsServices } from 'services/lcms.api';

export interface JobFamilyGroup {
  jobFamilyGroupID: string;
  jobFamilyGroupName: string;
}

export interface JobFamily {
  jobFamilyID: string;
  jobFamilyName: string;
}

export interface BusinessUnit {
  buCode: string;
  buName: string;
}

export interface PaginatedResponse<T> {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  message: string;
  data: T[];
}

interface JobFamilyGroupParams {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
}

interface JobFamilyParams {
  jobFamilyGroupID: string;
  pageNumber?: number;
  pageSize?: number;
}

interface BusinessUnitParams {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
}

export const jobFamilyService = {
  getJobFamilyGroups: async (
    params: JobFamilyGroupParams = {}
  ): Promise<PaginatedResponse<JobFamilyGroup>> => {
    const { search = '', pageNumber = 1, pageSize = 10 } = params;
    const response = await httpClient.get<PaginatedResponse<JobFamilyGroup>>(
      lcmsServices.LCMS.COURSES.LCMS_JOB_FAMILY_GROUPS,
      {
        params: { search, pageNumber, pageSize }
      }
    );
    return response.data;
  },

  getJobFamilies: async (params: JobFamilyParams): Promise<PaginatedResponse<JobFamily>> => {
    const { jobFamilyGroupID, pageNumber = 1, pageSize = 10 } = params;
    const response = await httpClient.get<PaginatedResponse<JobFamily>>(
      lcmsServices.LCMS.COURSES.LCMS_JOB_FAMILIES,
      {
        params: { jobFamilyGroupID, pageNumber, pageSize }
      }
    );
    return response.data;
  },

  getBusinessUnits: async (
    params: BusinessUnitParams = {}
  ): Promise<PaginatedResponse<BusinessUnit>> => {
    const { search = '', pageNumber = 1, pageSize = 10 } = params;
    const response = await httpClient.get<PaginatedResponse<BusinessUnit>>(
      lcmsServices.LCMS.COURSES.LCMS_BUSINESS_UNIT,
      {
        params: { search, pageNumber, pageSize }
      }
    );
    return response.data;
  }
};
